/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FolderExternal16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M5.846 3C6.923 3 6.654 4.077 8 4.077h5.385c.892 0 1.615.723 1.615 1.615v6.737c0 .892-.723 1.615-1.615 1.615H2.615A1.615 1.615 0 011 12.429V4.615C1 3.723 1.723 3 2.615 3h3.231zM8 7C6.509 7 5.308 8.201 5.308 9.692s1.2 2.693 2.692 2.693a2.687 2.687 0 002.692-2.693C10.692 8.202 9.492 7 8 7zM5.888 9.195l1.284 1.284v.29c0 .29.248.539.538.539v.538c-1.035-.166-1.864-1.035-1.864-2.154 0-.165.042-.331.042-.497zm2.94-1.49a2.13 2.13 0 011.326 1.987c0 .58-.207 1.077-.58 1.45-.083-.207-.29-.373-.497-.373h-.29v-.828c0-.124-.083-.249-.249-.249H6.923v-.538h.539c.165 0 .29-.124.29-.29v-.497h.538c.29 0 .538-.249.538-.539v-.124z"
        />
    </AccessibleSVG>
);

export default FolderExternal16;
